import { homeownerQuotesService } from '@/services/quotes/homeowner';
import type { GetPersonDataResponse } from '@/services/quotes/types';
import { useQuery } from '@tanstack/react-query';

export function usePersonData(registerNumber: string | undefined) {
  return useQuery<GetPersonDataResponse | null>({
    queryKey: ['quotes', 'person-data', registerNumber],
    queryFn: async () => {
      if (!registerNumber) return null;

      const response = await homeownerQuotesService.getPersonData({ registerNumber });

      if (!response.success || !response.data) {
        return null;
      }

      return response.data;
    },
    enabled:
      !!registerNumber &&
      (registerNumber.length === 11 || registerNumber.length === 14),
  });
}
